/**
 * @generated SignedSource<<83e4416d0cae88d6ee0a6d50172ebd35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item" | "PdpSharedIconBubbleEmail_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubblePinterest_item">;
  readonly " $fragmentType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$key = {
  readonly " $data"?: PdpRespIconBubbles_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2b2e55222b7c824838f7f79214e1f182";

export default node;
